import React, { useCallback } from 'react';
import { useField, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import PhoneInput from 'react-phone-input-2';

const BasePhoneInput = ({ name, initialValue, ...otherProps }) => {
  const [field, meta] = useField(name);
  const { setFieldValue, submitForm } = useFormikContext();
  const configInput = {
    ...field,
    ...otherProps,
  };

  if (meta && meta.error && meta.touched) {
    configInput.className = 'invalid';
  }

  const onChangePhone = useCallback(
    (phone) => {
      setFieldValue('phone', phone);
    },
    [setFieldValue]
  );

  return (
    <div
      onKeyDown={(e) => {
        if (e.keyCode === 13) {
          submitForm();
        }
      }}
    >
      <PhoneInput
        enableSearch
        country={'us'}
        onlyCountries={['us']}
        disableDropdown={true}
        placeholder='(201) 555-0123'
        disableCountryCode={true}
        value={initialValue || ''}
        onChange={onChangePhone}
        tabIndex='0'
        inputProps={{
          name: 'phone',
          required: true,
          autoFocus: window.innerWidth > 768 ? true : false,
        }}
      />

      {meta && meta.error && meta.touched && (
        <p style={{ marginTop: '15px', color: 'red' }}>{meta.error}</p>
      )}
    </div>
  );
};

// const Input = styled.input`
//   border: none;
//   background-color: transparent;
//   border-bottom: 1px solid #cac8b0;
//   font-size: 20px;
//   line-height: 24px;
//   padding: 0px 0px 8px;
//   border-radius: 0;
//   width: 100%;
//   ::placeholder {
//     color: #cac8b0;
//   }
//   &:focus {
//     outline: none;
//     box-shadow: rgb(100 78 2) 0px 2px;
//   }
//   &.invalid {
//     ::placeholder {
//       color: red;
//     }
//   }
// `;

BasePhoneInput.propTypes = {
  name: PropTypes.string,
  initialValue: PropTypes.string,
};

export default React.memo(BasePhoneInput);
